export const base = '/user-account'

export const login = () => '/login'
export const cormieCarersLogin = () => `${process.env.GATSBY_CORMIE_CARERS_URL}/login`
export const register = () => '/register'
export const passwordReset = () => '/password-reset'

export const details = () => `${base}`
export const orders = () => `${base}/orders`
export const cards = (id) => `${base}/cards${id ? `/${id}/edit` : ''}`
export const addresses = (id) => `${base}/addresses${id ? `/${id}/edit` : ''}`

export const newCard = () => `${base}/cards/new`
export const newAddress = () => `${base}/addresses/new`
export const editDetails = () => `${base}/edit`
